function Mobile() {
  return (
    <nav className="mmm">
      <div className="mmm-content">
        <ul className="mmm-list">
          <li>
            <a href="#intro">Início</a>
          </li>
          <li>
            <a href="#services">Serviços</a>
          </li>
          <li>
            <a href="#choose">Diferenciais</a>
          </li>
          <li>
            <a href="#counter">Números</a>
          </li>
          <li>
            <a href="#reviews">Depoimentos</a>
          </li>
          <li>
            <a href="#contact">Contato</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Mobile;
